<template>
    <div></div>
</template>

<script>
export default {
    props: {
        exponeaEventData: { required: true },
    },

    created() {
        document.addEventListener('exponeaLoaded', event => {
            exponea.track('view_category', this.exponeaEventData);
            // console.log("🚀 ~ file: product-list-exponea-event.vue ~ line 14 ~ created ~ this.exponeaEventData", this.exponeaEventData)
        });

        this.$root.$on('exponeaViewCategoryEvent', exponeaEventData => {
            exponea.track('view_category', exponeaEventData);
            // console.log("🚀 ~ file: product-list-exponea-event.vue ~ line 19 ~ created ~ exponeaEventData", exponeaEventData)
        });
    },
};
</script>

<style lang="scss" scoped></style>
